import PropTypes from 'prop-types'

/**
 * @typedef {Object} logbookPrivateUseModePropType
 * Defines the configuration for a logbook private use mode
 *
 * @property {String} logbookMode          - Logbook Mode configured.
 * @property {number} order                - To sort them by business needs
 * @property {String} stringcode           - String code for translation
 */
const logbookPrivateUseModePropType = PropTypes.shape({
    logbookMode: PropTypes.string.isRequired,
    order: PropTypes.number.isRequired,
    stringcode: PropTypes.string.isRequired
})

export { logbookPrivateUseModePropType }
